export {};

declare global {
  interface Array<T> {
    swap(source: number, destination: number): Array<T>;
  }
}

Array.prototype.swap = function <T>(source: number, destination: number): T[] {
  const arr = Array.from(this);
  [arr[source], arr[destination]] = [arr[destination], arr[source]];
  return arr;
};
